import angular from 'angular'
import switcherDirective from './switcherDirective'

export default angular
    .module('app.switcher', [])
    .directive('switcher', switcherDirective)
    .name



// WEBPACK FOOTER //
// ./src/components/switcher/index.js